class Timer {
  private timerId: number | undefined = undefined

  private readonly duration: number
  private _isInterval: boolean = false

  constructor(duration: number) {
    this.duration = duration
  }

  start(repeat: boolean = false, callback: () => void): void {
    this._isInterval = repeat ? true : false
    if (this.timerId === undefined) {
      if (repeat) {
        this.timerId = window.setInterval(() => {
          callback()
        }, this.duration)
      } else {
        this.timerId = window.setTimeout(() => {
          callback()
        }, this.duration)
      }
    }
  }

  stop(): void {
    if (this.timerId !== undefined) {
      if (this._isInterval) {
        clearInterval(this.timerId)
      } else {
        clearTimeout(this.timerId)
      }
      this.timerId = undefined
    }
  }
}

export { Timer }
